module.exports = __webpack_public_path__ + "img/class-portal-manage-active.b0b67b92.svg";